import { DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import {
  SaveButton,
  TextInput,
  SimpleForm,
  useDataProvider,
  useNotify,
  BooleanInput,
  useRefresh,
} from 'react-admin';

export default function EditInviteCode({
  id,
  resource,
  onClose,
}: {
  id: string;
  resource: any;
  onClose: () => void;
}) {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [saving, setSaving] = useState(false);
  const refresh = useRefresh();

  const onSubmit = async (values: any) => {
    setSaving(true);
    try {
      const processedValues = {
        code: values.code || null,
        userId: values.userId || null,
      };

      await dataProvider.update('invite-codes', {
        id: id, // id 是 code，dataProvider 会使用它作为路径参数
        data: processedValues,
        previousData: resource,
      } as any);
      notify('Invite code updated successfully', { type: 'success' });
      refresh();
      onClose();
    } catch (error: any) {
      console.error('Update error:', error);
      const errorMessage = error?.body?.message || error?.message || 'Failed to update invite code';
      notify(errorMessage, { type: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <DialogTitle>Edit Invite Code</DialogTitle>
      <DialogContent>
        <SimpleForm
          defaultValues={resource}
          onSubmit={onSubmit}
          toolbar={<SaveButton alwaysEnable disabled={saving} />}
        >
          <Stack spacing={2} sx={{ mt: 2 }}>
            <Typography variant="h6">Basic Information</Typography>
            <TextInput source="code" label="Code" fullWidth readOnly />
            <TextInput source="userId" label="User ID" fullWidth />
            <BooleanInput source="verified" label="Verified" readOnly />
          </Stack>
        </SimpleForm>
      </DialogContent>
    </>
  );
}

